export default __webpack_public_path__ + "static/media/noInternet.214539e8.svg";